import { Children, useEffect } from "react";
import { formatString } from "@format-string/core";
import { Box, LinearProgress } from "@mui/material";
import { PDFViewer, Document, View } from "@react-pdf/renderer";
import { useAuthContext } from "src/Contexts/AuthContext/authContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextReportsProduction } from "src/Contexts/ReportProduction/ReportsProductionContextContext";
import { PDFCabeçalho } from "src/Pages/components/PDF/Cabeçalho";
import { ItemMapToInfoSearch } from "src/Pages/components/PDF/ItemMapToInfoSearch";
import { LineItem } from "src/Pages/components/PDF/LineItem/LineItem";
import { NumberPages } from "src/Pages/components/PDF/NumberPages";
import { PageCorePDF } from "src/Pages/components/PDF/PageCorePDF";
import { TableBase } from "src/Pages/components/PDF/TableBase";
import { PDFTableRow } from "src/Pages/components/PDF/TableRow";
import { TableRowContainer } from "src/Pages/components/PDF/TableRowContainer";
import { handleFormatDateWithHours } from "src/shared/Utils/FormatDate/FormatDateToCodeProcucer";
import { FormatDateBR, GetDateUSSemValue } from "src/shared/Utils/FormatDateBR";
import { FormatMoney } from "src/shared/Utils/FormatMoney";
import { HandleGetHoursCurrency } from "src/shared/Utils/HandleGetHoursCurrency";
import { handleIfLimitCharacter } from "src/shared/Utils/LimitText";

import { HeadReportProductionSupervisor } from "./HeadReportProductionProducerPDF";

export const ReportProductionSupervisorPDF = () => {
  const { userPerfil } = useAuthContext();
  const { loadingGravar } = useConfigPageContext();
  const { listReportProductionSupervisor, setListReportProductionSupervisor } =
    useContextReportsProduction();

  const data = listReportProductionSupervisor?.data;
  const meta = listReportProductionSupervisor?.meta;
  const resume = listReportProductionSupervisor?.resume;

  console.log(data);

  // useEffect(() => setListReportProductionSupervisor(undefined), []);

  const tiposDate = {
    VIGENCIA: "Vigência",
    ASSINATURA: "Assinatura",
    EMISSAO: "Emissão",
  };

  return (
    <>
      {userPerfil && data?.supervisores.length && resume && meta && (
        <PDFViewer style={{ height: "84vh" }} width="100%">
          <Document
            creator="Brokeris"
            title={
              meta?.typeReport === "ALL"
                ? "Relatório de produção de supervisor"
                : `Relatório de produção de supervisor-${handleFormatDateWithHours()}`
            }
          >
            <PageCorePDF
              key={resume.totalQtdVidas}
              orientation="portrait"
              padding="16px 8px 30px 8px"
            >
              {meta?.dataPayments.startDate && meta?.dataPayments.endDate && (
                <PDFCabeçalho
                  dateCurrency={FormatDateBR(GetDateUSSemValue())}
                  empresa=""
                  endDate={FormatDateBR(meta.dataPayments.endDate)}
                  hoursCurrency={HandleGetHoursCurrency()}
                  nomePdf="Relatório de produção de supervisor"
                  startDate={FormatDateBR(meta.dataPayments.startDate)}
                />
              )}

              <View
                key={resume.totalQtdVidas}
                fixed
                style={{ borderBottom: "1px solid black", marginBottom: "14px", }}
              >
                <ItemMapToInfoSearch
                  itens={
                    meta?.typeReport === "UNIQUE" ? [data.supervisores[0].name] : []
                  }
                  title="Supervisor"
                />
                <ItemMapToInfoSearch
                  itens={[tiposDate[meta.dataPayments.typeDate]]}
                  title="Tipo de data"
                />
                <ItemMapToInfoSearch itens={meta?.filiais} title="Filiais" />
                <ItemMapToInfoSearch
                  itens={meta?.operadoras}
                  title="Operadoras"
                />
                <ItemMapToInfoSearch
                  itens={meta?.modalidades}
                  title="Modalidades"
                />
                <ItemMapToInfoSearch
                  itens={meta?.administradoras}
                  title="Administradoras"
                />
              </View>

              <TableBase key={resume.totalQtdVidas} margin="0">
                <HeadReportProductionSupervisor />

                {Children.toArray(
                  data.supervisores.map((supervisor, supervisorIndex) => {
                    return (
                      <>
                        <LineItem
                          id={supervisor.id}
                          name={supervisor.name}
                        />

                        <TableRowContainer key={`supervisor-${supervisorIndex}-resume`}>
                          <PDFTableRow
                            paddingLeft="8px"
                            fontSize={11}
                            title={`Total - ${supervisor.resume.totalQtdPropostas}`}
                            width="30%"
                          />
                          <PDFTableRow
                            textAlign="right"
                            fontSize={11}
                            title={FormatMoney(supervisor.resume.totalMensalidades.toFixed(2))}
                            width="30%"
                          />
                          <PDFTableRow
                            textAlign="center"
                            fontSize={11}
                            title={supervisor.resume.totalQtdPropostas.toString()}
                            width="20%"
                          />
                          <PDFTableRow
                            textAlign="center"
                            fontSize={11}
                            title={supervisor.resume.totalQtdVidas.toString()}
                            width="20%"
                          />
                        </TableRowContainer>
                      </>
                    );
                  })
                )}

                <TableRowContainer backgroundColor="#eeeeee">
                  <PDFTableRow
                    fontSize={11}
                    paddingLeft="8px"
                    title={`Total Geral`}
                    width="30%"
                  />

                  <PDFTableRow
                    fontSize={11}
                    textAlign="right"
                    title={FormatMoney(resume.totalMensalidades.toFixed(2))}
                    width="30%"
                  />
                  <PDFTableRow
                    fontSize={11}
                    textAlign="center"
                    title={resume.totalQtdPropostas.toString()}
                    width="20%"
                  />
                  <PDFTableRow
                    fontSize={11}
                    textAlign="center"
                    title={resume.totalQtdVidas.toString()}
                    width="20%"
                  />
                </TableRowContainer>
              </TableBase>

              <NumberPages />
            </PageCorePDF>
          </Document>
        </PDFViewer>
      )}

      {loadingGravar && (
        <Box style={{ width: "100%" }}>
          <LinearProgress color="inherit" />
        </Box>
      )}
    </>
  );
};
